define('ShowFacetsExtraValues.Facets.FacetedNavigationItem.View', [
    'Facets.FacetedNavigationItem.View',
    'ShowFacetsExtraValues.View',
    'underscore',
    'jQuery',
    'Backbone'
], function View(
    FacetsFacetedNavigationItemView,
    ShowFacetsExtraValuesView,
    _,
    jQuery,
    Backbone
) {
    'use strict';

    _.extend(FacetsFacetedNavigationItemView.prototype, {
        childViews: {
            'ExtraValuesView': function getExtraValuesView() {
                var context = this.getContext();
                this.showModel = new Backbone.Model({ show: false });
                return new ShowFacetsExtraValuesView({
                    extraValues: context.extraValues,
                    showModel: this.showModel
                });
            }
        },

        toggleSeeMoreLess: _.wrap(FacetsFacetedNavigationItemView.prototype.toggleSeeMoreLess, function (fn, event) {
            var target = jQuery(event.currentTarget);
            fn.apply(this, _.toArray(arguments).slice(1));
            this.showModel.set('show', target.data('collapsed'));
        })
    });
});
